import { Stack } from "@mui/material";

import ActionButton from "./ActionButton";
import RenderActionButtons from "./renderActionButtons";

export default function ActionButtonList() {
  const renderActionButtonsList = RenderActionButtons();
  return (
    <Stack
      spacing={0}
      direction="row"
      className="mr-16 flex items-center justify-end gap-3 text-white"
    >
      {renderActionButtonsList.map((actionButton, index) => (
        <ActionButton key={index} sx={{ minWidth: "fit-content" }}>
          {actionButton}
        </ActionButton>
      ))}
    </Stack>
  );
}
